//@ts-check

// Dynamic import approach using Vite's import.meta.glob
// This automatically loads all locale files in the common directory
const localeModules = import.meta.glob("./common/*.json", { eager: true });

// Convert the module paths to a simple locale-keyed object
const messages = {};
for (const path in localeModules) {
  // Extract locale from path: ./common/en-US.json -> en-US
  const locale = path.match(/\.\/common\/(.+)\.json$/)?.[1];
  if (locale) {
    // @ts-ignore - Dynamic module access
    messages[locale] = localeModules[path].default || localeModules[path];
  }
}

export default messages;

// ============================================================================
// ESCAPE HATCH: Plain JS imports (commented out)
// ============================================================================
// If import.meta.glob causes issues, you can uncomment this and comment out
// the import.meta.glob code above. This provides a simple, direct import
// approach with no build-time magic.
// ============================================================================

// import enUS from './common/en-US.json';
// import esMX from './common/es-MX.json';
//
// export default {
//   'en-US': enUS,
//   'es-MX': esMX,
// };
